
















import {
    defineComponent,
    computed,
} from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';

export default defineComponent({
    name: 'SdsGlobalHeaderIcon',
    props: {
        iconName: {
            type: String,
            required: true,
        },
        hasNotification: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup() {
        const isMobile = computed(() => isMobileLayout());

        return {
            isMobile,
        };
    },
    components: {
        SdsIcon,
    },
});
